// import React, { useEffect, useRef, useState } from "react";
// import Header from "../Header";
// import {
//   handleGetApiGF,
//   isWebView,
//   shareIphonePostMsg,
//   Toast,
//   Userlogin,
// } from "../Utils/general-function";
// import { useNavigate } from "react-router-dom";
// import Loader from "../Utils/Loader";
// import html2pdf from "html2pdf.js";
// import html2canvas from "html2canvas";

// function Challan(props) {
//   const [loading, setLoading] = useState(false);
//   const [carNumber, setCarNumber] = useState("");
//   const ChallanRef = useRef();
//   const [totalChallan, setTotalChallan] = useState(null);
//   const [challanData, setChallanData] = useState([]);
//   const [err, setErr] = useState("");
//   const navigate = useNavigate();

//   const OnChange = (e) => {
//     setCarNumber(e.target.value.toUpperCase());
//     setChallanData([]);
//   };
//   useEffect(() => {
//     if (!Userlogin()) {
//       navigate("/Login");
//       return;
//     }
//   }, []);
//   const validateVehicleNumber = (value) => {
//     const number = value.toUpperCase().replace(/[\s-]/g, "");
//     const normalVehicleRegex = /^[A-Z]{2}[0-9]{1,4}[A-Z]{1,3}[0-9]{4}$/;

//     const bhVehicleRegex = /^[0-9]{2}BH[0-9]{4}[A-Z]{2}$/;

//     return normalVehicleRegex.test(number) || bhVehicleRegex.test(number);
//   };
//   const onSubmit = async () => {
//     // const div = document.getElementById("result");
//     // const btndiv = document.getElementById("btndiv");
//     // div.style.display = "block";
//     // btndiv.style.display = "flex";
//     if (!validateVehicleNumber(carNumber)) {
//       setErr("Please enter a valid vehicle registration number.");
//       return;
//     } else {
//       setErr("");
//     }
//     setLoading(true);

//     try {
//       const res = await handleGetApiGF({
//         url: "/api/challanAPI/VehicalChallanAPI?Carno=" + carNumber,
//       });

//       setLoading(false);

//       if (!res?.succ) {
//         Toast(false, res?.msg, res?.msg);
//         return;
//       }
//       let parsedData = res?.data?.Data ? JSON.parse(res?.data?.Data) : {};
//       let data = parsedData?.data?.challan_details;

//       if (data.length < 1) {
//         Toast(false, "", parsedData?.message);
//       }
//       let totalChallan = data?.reduce(
//         (acc, data, i) => acc + parseFloat(data?.amount) || 0,
//         0,
//       );
//       setTotalChallan(totalChallan);
//       setChallanData(data);
//     } catch (error) {
//       setLoading(false);
//     }
//   };

//   const download = async () => {
//     setLoading(true);
//     let filename = carNumber + ".pdf";

//     // const div = document.getElementById("result");
//     const div = ChallanRef.current;
//     console.log("div", div);

// const options = {
//   pagebreak: { mode: ["avoid-all", "css", "legacy"] },
//   margin: [2, 2, 5, 5],
//   filename: carNumber + ".pdf",
//   image: {
//     type: "jpeg",
//     quality: 1.0,
//   },
//   html2canvas: {
//     scale: 2,
//     dpi: 192,
//     letterRendering: true,
//     allowTaint: true,
//   },
//   jsPDF: {
//     unit: "mm",
//     format: "a4",
//     orientation: "portrait",
//     compress: true,
//   },
// };
//     if (isWebView()) {
//       let bs64 = await html2pdf()
//         .from(div)
//         .set(options)
//         .toPdf()
//         .output("datauristring");
//       await shareIphonePostMsg({ data: bs64, filename, action: "sharebase64" });
//       setLoading(false);
//       return;
//     }
//     await html2pdf().from(div).set(options).toPdf().get("pdf").save();
//     setLoading(false);
//   };

//   const rupeeFormat = (rs) =>
//     rs.toLocaleString("en-IN", {
//       maximumFractionDigits: 0,
//       style: "currency",
//       currency: "INR",
//     });

//   useEffect(() => {
//     if (
//       !validateVehicleNumber(carNumber) &&
//       String(carNumber).trim().length > 0
//     ) {
//       setErr("Please enter a valid vehicle registration number.");
//       return;
//     } else {
//       setErr("");
//     }
//   }, [carNumber]);
//   return (
//     <div>
//       <Header />
//       {loading ? <Loader /> : null}
//       <div className="text-center">
//         <h2 className="page-title">Check Vehicle Challan</h2>
//       </div>
//       <div className="page-space">
//         <div className="input-group mt-2">
//           <input
//             type="text"
//             className="form-control"
//             placeholder="RC Number"
//             name="carNumber"
//             value={carNumber}
//             maxLength={10}
//             onChange={OnChange}
//           />
//           <button
//             className="btn rc-submit"
//             type="submit"
//             onClick={(e) => onSubmit()}
//           >
//             Submit
//           </button>
//         </div>
//         <p className="text-danger">{err}</p>
//         )}
//         {challanData.length > 0 && (
//           <>
//             <div
//               className="justify-content-center mb-2"
//               id="btndiv"
//               style={{ display: "flex" }}
//             >
//               <button
//                 className="btn rc-submit mt-3"
//                 style={{ lineHeight: "18px" }}
//                 type="submit"
//                 onClick={(e) => download()}
//               >
//                 Download Pdf
//               </button>
//               {/* <button className="cardoc-btn">
//             <img
//               src="assets/images/share-d.png"
//               alt="share"
//               style={{ width: "32px" }}
//               onClick={(e) => share()}
//             />
//           </button> */}
//             </div>
//             <div id="result" style={{ display: "block" }} ref={ChallanRef}>
//               <div className="pt-2">
//                 <div className="d-flex text-center flex-column">
//                   <span>
//                     <img
//                       src="assets/images/logo.png"
//                       style={{ maxWidth: "120px" }}
//                       alt=""
//                     />
//                   </span>
//                   <h4 className="ch-carno">{carNumber}</h4>
//                 </div>
//               </div>
//               {challanData.map((data, i) => (
//                 <div className="challan-div" key={data?.challanNumber}>
//                   <span style={{ fontSize: "16px" }}>
//                     Challan No-{data?.challan_number}
//                   </span>
//                   <div className="ch-details">
//                     <div>
//                       <span>Name- </span>
//                       {data?.accused_name}
//                     </div>
//                     <div>
//                       <span>Challan Place</span> - {data?.challan_place}
//                     </div>
//                     <div>
//                       <span>RTO</span> - {data?.rto}
//                     </div>
//                     <div>
//                       <span>State</span> - {data?.state}
//                     </div>
//                     <div>
//                       <span>Challan Date</span> -{" "}
//                       {new Date(data?.challan_date).toLocaleDateString("es-CL")}
//                       {" : "}
//                       {data?.challan_date_time?.split("T")?.[1]}
//                     </div>
//                     <div>
//                       <span>Amount</span> -{" "}
//                       {rupeeFormat(parseFloat(data?.amount) || 0)}
//                     </div>
//                     <div>
//                       <span>Challan Status</span> - {data?.challan_status}
//                     </div>

//                     <div>
//                       <span>Offense Detail</span> - {data?.offense_details}
//                     </div>
//                     <div>
//                       <span>Court Challan</span> -{" "}
//                       {data?.court_challan === true ? "Yes" : "No"}
//                     </div>

//                     {/* <div>
//                   <span>Receipt No </span> -{" "}
//                 </div>
//                 <div>
//                   <span>Payment Mode </span> -{" "}
//                 </div>
//                 <div>
//                   <span>Payment Date </span> -{" "}
//                 </div> */}
//                   </div>

//                   {challanData.length === i + 1 && (
//                     <h1 className="mt-3 text-center text-danger">
//                       Total Challan :{" "}
//                       {rupeeFormat(parseFloat(totalChallan) || 0)}
//                     </h1>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </>
//       </div>
//     </div>
//   );
// }

// export default Challan;

// NEW DEMO BELLOW

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import Header from "../Header";
import Loader from "../Utils/Loader";

import {
  handleGetApiGF,
  isWebView,
  shareIphonePostMsg,
  Toast,
  Userlogin,
} from "../Utils/general-function";

import "../../css/vehicle_challan.css";

function Challan() {
  const navigate = useNavigate();

  // Screen result
  const challanRef = useRef(null);

  // PDF result
  const pdfRef = useRef(null);

  const [carNumber, setCarNumber] = useState("");
  const [challanData, setChallanData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [input, setInput] = useState({
    challanStatusKey: "",
    challanDataBasedOnStatus: [],
  });

  const challanStatusKeyObject = {
    Disposed: "Completed",
    Pending: "Pending",
  };

  /* =====================================================
     VEHICLE NUMBER
  ===================================================== */

  const normalizeVehicleNumber = (value = "") => {
    return value.toUpperCase().replace(/[\s-]/g, "").trim();
  };

  const validateVehicleNumber = (value = "") => {
    const number = normalizeVehicleNumber(value);

    const normalVehicleRegex = /^[A-Z]{2}[0-9]{1,4}[A-Z]{1,3}[0-9]{4}$/;

    const bhVehicleRegex = /^[0-9]{2}BH[0-9]{4}[A-Z]{2}$/;

    return normalVehicleRegex.test(number) || bhVehicleRegex.test(number);
  };

  /* =====================================================
     LOGIN
  ===================================================== */

  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
    }
  }, [navigate]);

  /* =====================================================
     FORMAT
  ===================================================== */

  const formatRupee = (amount = 0) => {
    return Number(amount || 0).toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    });
  };

  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (value) => {
    if (!value) return "-";

    try {
      const time = value.split("T")?.[1];

      if (!time) return "-";

      return time.substring(0, 5);
    } catch {
      return "-";
    }
  };

  /* =====================================================
     INPUT
  ===================================================== */

  const handleVehicleChange = (e) => {
    const value = e.target.value.toUpperCase();

    setCarNumber(value);

    // Clear previous result
    setChallanData([]);
    setTotalAmount(0);

    if (!value.trim()) {
      setError("");
      return;
    }

    if (!validateVehicleNumber(value)) {
      setError("Please enter a valid vehicle registration number.");
    } else {
      setError("");
    }
  };

  /* =====================================================
     GET CHALLAN
  ===================================================== */

  const handleSubmit = async () => {
    const vehicleNumber = normalizeVehicleNumber(carNumber);

    if (!vehicleNumber) {
      setError("Please enter vehicle registration number.");
      return;
    }

    if (!validateVehicleNumber(vehicleNumber)) {
      setError("Please enter a valid vehicle registration number.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await handleGetApiGF({
        url:
          "/api/challanAPI/VehicalChallanAPI?Carno=" +
          encodeURIComponent(vehicleNumber),
      });

      if (!res?.succ) {
        Toast(false, res?.msg || "Unable to fetch challan.", res?.msg);
        return;
      }

      let parsedData = {};

      try {
        parsedData = res?.data?.Data ? JSON.parse(res.data.Data) : {};
      } catch (parseError) {
        console.error("Challan response parse error:", parseError);

        Toast(
          false,
          "Invalid challan response.",
          "Unable to read server response.",
        );

        return;
      }

      const data = parsedData?.data?.challan_details || [];

      if (!Array.isArray(data) || data.length === 0) {
        setChallanData([]);
        setTotalAmount(0);

        Toast(false, "", parsedData?.message || "No challan found.");

        return;
      }

      const total = data.reduce((sum, item) => {
        return sum + (Number.parseFloat(item?.amount) || 0);
      }, 0);

      setCarNumber(vehicleNumber);
      setChallanData(data);
      setTotalAmount(total);
    } catch (error) {
      console.error("Challan API Error:", error);

      Toast(
        false,
        "Unable to fetch challan details.",
        "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     PDF
  ===================================================== */

  const handleDownloadPdf = async () => {
    // if (!pdfRef.current || challanData.length === 0) {
    //   return;
    // }

    setLoading(true);

    const filename = `${normalizeVehicleNumber(carNumber)}-challan.pdf`;

    try {
      // Make sure the PDF element is actually rendered
      const element = pdfRef.current;

      if (!element) {
        throw new Error("PDF element not found.");
      }

      const options = {
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        // margin: [2, 2, 5, 5],
        margin: [5, 5, 5, 5],
        filename: carNumber + ".pdf",
        image: {
          type: "jpeg",
          quality: 1.0,
        },
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
          compress: true,
        },
      };

      const worker = html2pdf()
        .set(options)
        .from(element)
        .toContainer()
        .toCanvas()
        .toImg()
        .toPdf();

      const pdf = await worker.get("pdf");

      if (!pdf) {
        throw new Error("Unable to create jsPDF instance.");
      }

      if (isWebView()) {
        const base64 = pdf.output("datauristring");

        if (!base64) {
          throw new Error("PDF base64 is empty.");
        }

        await shareIphonePostMsg({
          data: base64,
          filename,
          action: "sharebase64",
        });
      } else {
        pdf.save(filename);
        Toast(true, "Download Successfully", "");
      }
    } catch (error) {
      console.error("Challan PDF Error:", error);

      Toast(false, "Unable to generate PDF.", "Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     CLEAR
  ===================================================== */

  const handleClear = () => {
    setCarNumber("");
    setChallanData([]);
    setTotalAmount(0);
    setError("");
  };

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setInput((pre) => ({ ...pre, [name]: value }));
  };

  // re-call useeffect on challan status key changed
  useEffect(() => {
    let filteredData = Array.isArray(challanData)
      ? challanData.filter((d) =>
          input.challanStatusKey
            ? d?.challan_status === input.challanStatusKey
            : d,
        )
      : [];
    setTotalAmount(
      Array.isArray(filteredData)
        ? filteredData.reduce((sum, item) => {
            return sum + (Number.parseFloat(item?.amount) || 0);
          }, 0)
        : 0,
    );
    setInput((pre) => ({
      ...pre,
      challanDataBasedOnStatus: filteredData || [],
    }));
  }, [input.challanStatusKey, challanData]);

  /* =====================================================
     RENDER
  ===================================================== */
  const { challanDataBasedOnStatus, challanStatusKey } = input;
  return (
    <>
      <div className="page-space">
        <Header />

        {loading && <Loader />}

        {/* =================================================
            PAGE TITLE
        ================================================= */}

        <div className="text-center">
          <h2 className="page-title">Check Vehicle Challan</h2>
        </div>

        <main className="challan-container">
          {/* =================================================
              SEARCH
          ================================================= */}

          <section className="challan-search-card">
            <div className="challan-search-heading">
              <div className="challan-car-icon">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M5 17h14l1-5-2-5H6l-2 5 1 5Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M4 12h16M7 17v2M17 17v2M6 8l-1-2M18 8l1-2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                  />

                  <circle cx="7" cy="14.5" r="1" fill="currentColor" />

                  <circle cx="17" cy="14.5" r="1" fill="currentColor" />
                </svg>
              </div>

              <div>
                <h2>Enter Vehicle Number</h2>
                <span>Check pending challans</span>
              </div>
            </div>

            <div className="challan-input-row">
              <div className="challan-input-wrapper">
                <input
                  type="text"
                  id="carNumber"
                  name="carNumber"
                  value={carNumber}
                  maxLength={10}
                  autoComplete="off"
                  spellCheck="false"
                  placeholder="GJ01AB1234"
                  className={`challan-input ${
                    error ? "challan-input-error" : ""
                  }`}
                  onChange={handleVehicleChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSubmit();
                    }
                  }}
                />

                {carNumber && (
                  <button
                    type="button"
                    className="challan-clear-btn"
                    onClick={handleClear}
                    aria-label="Clear vehicle number"
                  >
                    ×
                  </button>
                )}
              </div>

              <button
                type="button"
                className="challan-search-btn"
                disabled={loading}
                onClick={handleSubmit}
              >
                Check Challan {"->"}
              </button>
            </div>

            {error && <div className="challan-error">{error}</div>}

            <div className="challan-hint">Example: GJ01AB1234</div>
          </section>

          {/* =================================================
              RESULT
          ================================================= */}

          {challanData.length > 0 && (
            <section className="challan-results" ref={challanRef}>
              {/*challan status DROP DOWN */}
              <section className="w-100 form-div">
                <label className="form-label">Challan Status</label>
                <select
                  name="challanStatusKey"
                  className="form-select form-control"
                  value={challanStatusKey}
                  onChange={onChangeInput}
                >
                  <option value="">All</option>
                  <option value="Disposed">Completed</option>
                  <option value="Pending">Pending</option>
                </select>
              </section>

              {/* DOWNLOAD */}
              <button
                type="button"
                className="challan-download-btn"
                onClick={handleDownloadPdf}
                disabled={loading}
              >
                <span className="download-icon">
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M12 4v11M8 11l4 4 4-4M5 19h14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                Download Challan Report
              </button>

              {/* CHALLAN CARDS */}

              <div>
                {/* SUMMARY */}

                <>
                  <div id="result" ref={pdfRef} style={{ display: "block" }}>
                    <div className="pt-2 d-flex justify-content-evenly">
                      <div className="d-flex text-center flex-column">
                        <span>
                          <img
                            src="assets/images/logo.png"
                            style={{ maxWidth: "120px" }}
                            alt=""
                          />
                        </span>
                      </div>{" "}
                      <div className="challan-result-header">
                        <div>
                          <div className="challan-result-header-label">
                            CHALLAN REPORT
                          </div>

                          <h2>{normalizeVehicleNumber(carNumber)}</h2>
                        </div>
                      </div>
                    </div>
                    <div className="challan-summary">
                      <div className="challan-summary-card">
                        <span className="summary-icon">
                          <svg viewBox="0 0 24 24">
                            <path
                              d="M4 5h16v14H4zM8 9h8M8 13h5"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>

                        <div>
                          <span>
                            {challanStatusKey
                              ? challanStatusKeyObject[challanStatusKey]
                              : "Total"}{" "}
                            Challans
                          </span>
                          <strong>{challanDataBasedOnStatus.length}</strong>
                        </div>
                      </div>

                      <div className="challan-summary-card amount">
                        <span className="summary-icon">₹</span>

                        <div>
                          <span>Total Amount</span>
                          <strong>{formatRupee(totalAmount)}</strong>
                        </div>
                      </div>
                    </div>
                    {challanDataBasedOnStatus?.map((data, i) => (
                      <div className="challan-div" key={data?.challanNumber}>
                        <span style={{ fontSize: "16px" }}>
                          Challan No-{data?.challan_number}
                        </span>
                        <div className="ch-details">
                          <div>
                            <span>Name- </span>
                            {data?.accused_name}
                          </div>
                          <div>
                            <span>Challan Place</span> - {data?.challan_place}
                          </div>
                          <div>
                            <span>RTO</span> - {data?.rto}
                          </div>
                          <div>
                            <span>State</span> - {data?.state}
                          </div>
                          <div>
                            <span>Challan Date</span> -{" "}
                            {/* {new Date(data?.challan_date).toLocaleDateString(
                                "es-CL",
                              )} */}
                            {formatDate(data?.challan_date)}
                            {" : "}
                            {data?.challan_date_time?.split("T")?.[1]}
                          </div>
                          <div>
                            <span>Amount</span> -{" "}
                            {formatRupee(parseFloat(data?.amount) || 0)}
                          </div>
                          <div>
                            <span>Challan Status</span> - {data?.challan_status}
                          </div>

                          <div>
                            <span>Offense Detail</span> -{" "}
                            {data?.offense_details}
                          </div>
                          <div>
                            <span>Court Challan</span> -{" "}
                            {data?.court_challan === true ? "Yes" : "No"}
                          </div>
                        </div>

                        {/* {challanData.length === i + 1 && (
                            <h1 className="mt-3 text-center text-danger">
                              Total Challan :{" "}
                              {formatRupee(parseFloat(totalAmount) || 0)}
                            </h1>
                          )} */}
                      </div>
                    ))}
                  </div>
                </>
              </div>
            </section>
          )}
        </main>
      </div>
    </>
  );
}

export default Challan;

//WITHOUT SEPRATING PENDING AND COMPLETED
// // import React, { useEffect, useRef, useState } from "react";
// // import Header from "../Header";
// // import {
// //   handleGetApiGF,
// //   isWebView,
// //   shareIphonePostMsg,
// //   Toast,
// //   Userlogin,
// // } from "../Utils/general-function";
// // import { useNavigate } from "react-router-dom";
// // import Loader from "../Utils/Loader";
// // import html2pdf from "html2pdf.js";
// // import html2canvas from "html2canvas";

// // function Challan(props) {
// //   const [loading, setLoading] = useState(false);
// //   const [carNumber, setCarNumber] = useState("");
// //   const ChallanRef = useRef();
// //   const [totalChallan, setTotalChallan] = useState(null);
// //   const [challanData, setChallanData] = useState([]);
// //   const [err, setErr] = useState("");
// //   const navigate = useNavigate();

// //   const OnChange = (e) => {
// //     setCarNumber(e.target.value.toUpperCase());
// //     setChallanData([]);
// //   };
// //   useEffect(() => {
// //     if (!Userlogin()) {
// //       navigate("/Login");
// //       return;
// //     }
// //   }, []);
// //   const validateVehicleNumber = (value) => {
// //     const number = value.toUpperCase().replace(/[\s-]/g, "");
// //     const normalVehicleRegex = /^[A-Z]{2}[0-9]{1,4}[A-Z]{1,3}[0-9]{4}$/;

// //     const bhVehicleRegex = /^[0-9]{2}BH[0-9]{4}[A-Z]{2}$/;

// //     return normalVehicleRegex.test(number) || bhVehicleRegex.test(number);
// //   };
// //   const onSubmit = async () => {
// //     // const div = document.getElementById("result");
// //     // const btndiv = document.getElementById("btndiv");
// //     // div.style.display = "block";
// //     // btndiv.style.display = "flex";
// //     if (!validateVehicleNumber(carNumber)) {
// //       setErr("Please enter a valid vehicle registration number.");
// //       return;
// //     } else {
// //       setErr("");
// //     }
// //     setLoading(true);

// //     try {
// //       const res = await handleGetApiGF({
// //         url: "/api/challanAPI/VehicalChallanAPI?Carno=" + carNumber,
// //       });

// //       setLoading(false);

// //       if (!res?.succ) {
// //         Toast(false, res?.msg, res?.msg);
// //         return;
// //       }
// //       let parsedData = res?.data?.Data ? JSON.parse(res?.data?.Data) : {};
// //       let data = parsedData?.data?.challan_details;

// //       if (data.length < 1) {
// //         Toast(false, "", parsedData?.message);
// //       }
// //       let totalChallan = data?.reduce(
// //         (acc, data, i) => acc + parseFloat(data?.amount) || 0,
// //         0,
// //       );
// //       setTotalChallan(totalChallan);
// //       setChallanData(data);
// //     } catch (error) {
// //       setLoading(false);
// //     }
// //   };

// //   const download = async () => {
// //     setLoading(true);
// //     let filename = carNumber + ".pdf";

// //     // const div = document.getElementById("result");
// //     const div = ChallanRef.current;
// //     console.log("div", div);

// // const options = {
// //   pagebreak: { mode: ["avoid-all", "css", "legacy"] },
// //   margin: [2, 2, 5, 5],
// //   filename: carNumber + ".pdf",
// //   image: {
// //     type: "jpeg",
// //     quality: 1.0,
// //   },
// //   html2canvas: {
// //     scale: 2,
// //     dpi: 192,
// //     letterRendering: true,
// //     allowTaint: true,
// //   },
// //   jsPDF: {
// //     unit: "mm",
// //     format: "a4",
// //     orientation: "portrait",
// //     compress: true,
// //   },
// // };
// //     if (isWebView()) {
// //       let bs64 = await html2pdf()
// //         .from(div)
// //         .set(options)
// //         .toPdf()
// //         .output("datauristring");
// //       await shareIphonePostMsg({ data: bs64, filename, action: "sharebase64" });
// //       setLoading(false);
// //       return;
// //     }
// //     await html2pdf().from(div).set(options).toPdf().get("pdf").save();
// //     setLoading(false);
// //   };

// //   const rupeeFormat = (rs) =>
// //     rs.toLocaleString("en-IN", {
// //       maximumFractionDigits: 0,
// //       style: "currency",
// //       currency: "INR",
// //     });

// //   useEffect(() => {
// //     if (
// //       !validateVehicleNumber(carNumber) &&
// //       String(carNumber).trim().length > 0
// //     ) {
// //       setErr("Please enter a valid vehicle registration number.");
// //       return;
// //     } else {
// //       setErr("");
// //     }
// //   }, [carNumber]);
// //   return (
// //     <div>
// //       <Header />
// //       {loading ? <Loader /> : null}
// //       <div className="text-center">
// //         <h2 className="page-title">Check Vehicle Challan</h2>
// //       </div>
// //       <div className="page-space">
// //         <div className="input-group mt-2">
// //           <input
// //             type="text"
// //             className="form-control"
// //             placeholder="RC Number"
// //             name="carNumber"
// //             value={carNumber}
// //             maxLength={10}
// //             onChange={OnChange}
// //           />
// //           <button
// //             className="btn rc-submit"
// //             type="submit"
// //             onClick={(e) => onSubmit()}
// //           >
// //             Submit
// //           </button>
// //         </div>
// //         <p className="text-danger">{err}</p>
// //         )}
// //         {challanData.length > 0 && (
// //           <>
// //             <div
// //               className="justify-content-center mb-2"
// //               id="btndiv"
// //               style={{ display: "flex" }}
// //             >
// //               <button
// //                 className="btn rc-submit mt-3"
// //                 style={{ lineHeight: "18px" }}
// //                 type="submit"
// //                 onClick={(e) => download()}
// //               >
// //                 Download Pdf
// //               </button>
// //               {/* <button className="cardoc-btn">
// //             <img
// //               src="assets/images/share-d.png"
// //               alt="share"
// //               style={{ width: "32px" }}
// //               onClick={(e) => share()}
// //             />
// //           </button> */}
// //             </div>
// //             <div id="result" style={{ display: "block" }} ref={ChallanRef}>
// //               <div className="pt-2">
// //                 <div className="d-flex text-center flex-column">
// //                   <span>
// //                     <img
// //                       src="assets/images/logo.png"
// //                       style={{ maxWidth: "120px" }}
// //                       alt=""
// //                     />
// //                   </span>
// //                   <h4 className="ch-carno">{carNumber}</h4>
// //                 </div>
// //               </div>
// //               {challanData.map((data, i) => (
// //                 <div className="challan-div" key={data?.challanNumber}>
// //                   <span style={{ fontSize: "16px" }}>
// //                     Challan No-{data?.challan_number}
// //                   </span>
// //                   <div className="ch-details">
// //                     <div>
// //                       <span>Name- </span>
// //                       {data?.accused_name}
// //                     </div>
// //                     <div>
// //                       <span>Challan Place</span> - {data?.challan_place}
// //                     </div>
// //                     <div>
// //                       <span>RTO</span> - {data?.rto}
// //                     </div>
// //                     <div>
// //                       <span>State</span> - {data?.state}
// //                     </div>
// //                     <div>
// //                       <span>Challan Date</span> -{" "}
// //                       {new Date(data?.challan_date).toLocaleDateString("es-CL")}
// //                       {" : "}
// //                       {data?.challan_date_time?.split("T")?.[1]}
// //                     </div>
// //                     <div>
// //                       <span>Amount</span> -{" "}
// //                       {rupeeFormat(parseFloat(data?.amount) || 0)}
// //                     </div>
// //                     <div>
// //                       <span>Challan Status</span> - {data?.challan_status}
// //                     </div>

// //                     <div>
// //                       <span>Offense Detail</span> - {data?.offense_details}
// //                     </div>
// //                     <div>
// //                       <span>Court Challan</span> -{" "}
// //                       {data?.court_challan === true ? "Yes" : "No"}
// //                     </div>

// //                     {/* <div>
// //                   <span>Receipt No </span> -{" "}
// //                 </div>
// //                 <div>
// //                   <span>Payment Mode </span> -{" "}
// //                 </div>
// //                 <div>
// //                   <span>Payment Date </span> -{" "}
// //                 </div> */}
// //                   </div>

// //                   {challanData.length === i + 1 && (
// //                     <h1 className="mt-3 text-center text-danger">
// //                       Total Challan :{" "}
// //                       {rupeeFormat(parseFloat(totalChallan) || 0)}
// //                     </h1>
// //                   )}
// //                 </div>
// //               ))}
// //             </div>
// //           </>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Challan;

// // NEW DEMO BELLOW

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import html2pdf from "html2pdf.js";
// import Header from "../Header";
// import Loader from "../Utils/Loader";

// import {
//   handleGetApiGF,
//   isWebView,
//   shareIphonePostMsg,
//   Toast,
//   Userlogin,
// } from "../Utils/general-function";

// import "../../css/vehicle_challan.css";

// function Challan() {
//   const navigate = useNavigate();

//   // Screen result
//   const challanRef = useRef(null);

//   // PDF result
//   const pdfRef = useRef(null);

//   const [carNumber, setCarNumber] = useState("");
//   const [challanData, setChallanData] = useState([]);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   /* =====================================================
//      VEHICLE NUMBER
//   ===================================================== */

//   const normalizeVehicleNumber = (value = "") => {
//     return value.toUpperCase().replace(/[\s-]/g, "").trim();
//   };

//   const validateVehicleNumber = (value = "") => {
//     const number = normalizeVehicleNumber(value);

//     const normalVehicleRegex = /^[A-Z]{2}[0-9]{1,4}[A-Z]{1,3}[0-9]{4}$/;

//     const bhVehicleRegex = /^[0-9]{2}BH[0-9]{4}[A-Z]{2}$/;

//     return normalVehicleRegex.test(number) || bhVehicleRegex.test(number);
//   };

//   /* =====================================================
//      LOGIN
//   ===================================================== */

//   useEffect(() => {
//     if (!Userlogin()) {
//       navigate("/Login");
//     }
//   }, [navigate]);

//   /* =====================================================
//      FORMAT
//   ===================================================== */

//   const formatRupee = (amount = 0) => {
//     return Number(amount || 0).toLocaleString("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     });
//   };

//   const formatDate = (date) => {
//     if (!date) return "-";

//     const parsedDate = new Date(date);

//     if (Number.isNaN(parsedDate.getTime())) {
//       return "-";
//     }

//     return parsedDate.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const formatTime = (value) => {
//     if (!value) return "-";

//     try {
//       const time = value.split("T")?.[1];

//       if (!time) return "-";

//       return time.substring(0, 5);
//     } catch {
//       return "-";
//     }
//   };

//   /* =====================================================
//      INPUT
//   ===================================================== */

//   const handleVehicleChange = (e) => {
//     const value = e.target.value.toUpperCase();

//     setCarNumber(value);

//     // Clear previous result
//     setChallanData([]);
//     setTotalAmount(0);

//     if (!value.trim()) {
//       setError("");
//       return;
//     }

//     if (!validateVehicleNumber(value)) {
//       setError("Please enter a valid vehicle registration number.");
//     } else {
//       setError("");
//     }
//   };

//   /* =====================================================
//      GET CHALLAN
//   ===================================================== */

//   const handleSubmit = async () => {
//     const vehicleNumber = normalizeVehicleNumber(carNumber);

//     if (!vehicleNumber) {
//       setError("Please enter vehicle registration number.");
//       return;
//     }

//     if (!validateVehicleNumber(vehicleNumber)) {
//       setError("Please enter a valid vehicle registration number.");
//       return;
//     }

//     setError("");
//     setLoading(true);

//     try {
//       const res = await handleGetApiGF({
//         url:
//           "/api/challanAPI/VehicalChallanAPI?Carno=" +
//           encodeURIComponent(vehicleNumber),
//       });

//       if (!res?.succ) {
//         Toast(false, res?.msg || "Unable to fetch challan.", res?.msg);
//         return;
//       }

//       let parsedData = {};

//       try {
//         parsedData = res?.data?.Data ? JSON.parse(res.data.Data) : {};
//       } catch (parseError) {
//         console.error("Challan response parse error:", parseError);

//         Toast(
//           false,
//           "Invalid challan response.",
//           "Unable to read server response.",
//         );

//         return;
//       }

//       const data = parsedData?.data?.challan_details || [];

//       if (!Array.isArray(data) || data.length === 0) {
//         setChallanData([]);
//         setTotalAmount(0);

//         Toast(false, "", parsedData?.message || "No challan found.");

//         return;
//       }

//       const total = data.reduce((sum, item) => {
//         return sum + (Number.parseFloat(item?.amount) || 0);
//       }, 0);

//       setCarNumber(vehicleNumber);
//       setChallanData(data);
//       setTotalAmount(total);
//     } catch (error) {
//       console.error("Challan API Error:", error);

//       Toast(
//         false,
//         "Unable to fetch challan details.",
//         "Something went wrong. Please try again.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      PDF
//   ===================================================== */

//   const handleDownloadPdf = async () => {
//     if (!pdfRef.current || challanData.length === 0) {
//       return;
//     }

//     setLoading(true);

//     const filename = `${normalizeVehicleNumber(carNumber)}-challan.pdf`;

//     try {
//       // Make sure the PDF element is actually rendered
//       const element = pdfRef.current;

//       if (!element) {
//         throw new Error("PDF element not found.");
//       }

//       const options = {
//         pagebreak: { mode: ["avoid-all", "css", "legacy"] },
//         // margin: [2, 2, 5, 5],
//         margin: [5, 5, 5, 5],
//         filename: carNumber + ".pdf",
//         image: {
//           type: "jpeg",
//           quality: 1.0,
//         },
//         html2canvas: {
//           scale: 2,
//           dpi: 192,
//           letterRendering: true,
//           allowTaint: true,
//         },
//         jsPDF: {
//           unit: "mm",
//           format: "a4",
//           orientation: "portrait",
//           compress: true,
//         },
//       };

//       const worker = html2pdf()
//         .set(options)
//         .from(element)
//         .toContainer()
//         .toCanvas()
//         .toImg()
//         .toPdf();

//       const pdf = await worker.get("pdf");

//       if (!pdf) {
//         throw new Error("Unable to create jsPDF instance.");
//       }

//       if (isWebView()) {
//         const base64 = pdf.output("datauristring");

//         if (!base64) {
//           throw new Error("PDF base64 is empty.");
//         }

//         await shareIphonePostMsg({
//           data: base64,
//           filename,
//           action: "sharebase64",
//         });
//       } else {
//         pdf.save(filename);
//         Toast(true, "Download Successfully", "");
//       }
//     } catch (error) {
//       console.error("Challan PDF Error:", error);

//       Toast(false, "Unable to generate PDF.", "Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      CLEAR
//   ===================================================== */

//   const handleClear = () => {
//     setCarNumber("");
//     setChallanData([]);
//     setTotalAmount(0);
//     setError("");
//   };

//   /* =====================================================
//      RENDER
//   ===================================================== */

//   return (
//     <>
//       <div className="page-space">
//         <Header />

//         {loading && <Loader />}

//         {/* =================================================
//             PAGE TITLE
//         ================================================= */}

//         <div className="text-center">
//           <h2 className="page-title">Check Vehicle Challan</h2>
//         </div>

//         <main className="challan-container">
//           {/* =================================================
//               SEARCH
//           ================================================= */}

//           <section className="challan-search-card">
//             <div className="challan-search-heading">
//               <div className="challan-car-icon">
//                 <svg viewBox="0 0 24 24">
//                   <path
//                     d="M5 17h14l1-5-2-5H6l-2 5 1 5Z"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="1.7"
//                     strokeLinejoin="round"
//                   />

//                   <path
//                     d="M4 12h16M7 17v2M17 17v2M6 8l-1-2M18 8l1-2"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="1.7"
//                     strokeLinecap="round"
//                   />

//                   <circle cx="7" cy="14.5" r="1" fill="currentColor" />

//                   <circle cx="17" cy="14.5" r="1" fill="currentColor" />
//                 </svg>
//               </div>

//               <div>
//                 <h2>Enter Vehicle Number</h2>
//                 <span>Check pending challans</span>
//               </div>
//             </div>

//             <div className="challan-input-row">
//               <div className="challan-input-wrapper">
//                 <input
//                   type="text"
//                   id="carNumber"
//                   name="carNumber"
//                   value={carNumber}
//                   maxLength={10}
//                   autoComplete="off"
//                   spellCheck="false"
//                   placeholder="GJ01AB1234"
//                   className={`challan-input ${
//                     error ? "challan-input-error" : ""
//                   }`}
//                   onChange={handleVehicleChange}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       handleSubmit();
//                     }
//                   }}
//                 />

//                 {carNumber && (
//                   <button
//                     type="button"
//                     className="challan-clear-btn"
//                     onClick={handleClear}
//                     aria-label="Clear vehicle number"
//                   >
//                     ×
//                   </button>
//                 )}
//               </div>

//               <button
//                 type="button"
//                 className="challan-search-btn"
//                 disabled={loading}
//                 onClick={handleSubmit}
//               >
//                 Check Challan {"->"}
//               </button>
//             </div>

//             {error && <div className="challan-error">{error}</div>}

//             <div className="challan-hint">Example: GJ01AB1234</div>
//           </section>

//           {/* =================================================
//               RESULT
//           ================================================= */}

//           {challanData.length > 0 && (
//             <section className="challan-results" ref={challanRef}>
//               {/* DOWNLOAD */}

//               <button
//                 type="button"
//                 className="challan-download-btn"
//                 onClick={handleDownloadPdf}
//                 disabled={loading}
//               >
//                 <span className="download-icon">
//                   <svg viewBox="0 0 24 24">
//                     <path
//                       d="M12 4v11M8 11l4 4 4-4M5 19h14"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="1.8"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </span>
//                 Download Challan Report
//               </button>

//               {/* CHALLAN CARDS */}

//               <div ref={pdfRef}>
//                 {/* SUMMARY */}

//                 {challanData.length > 0 && (
//                   <>
//                     <div id="result" ref={pdfRef} style={{ display: "block" }}>
//                       <div className="pt-2 d-flex justify-content-evenly">
//                         <div className="d-flex text-center flex-column">
//                           <span>
//                             <img
//                               src="assets/images/logo.png"
//                               style={{ maxWidth: "120px" }}
//                               alt=""
//                             />
//                           </span>
//                         </div>{" "}
//                         <div className="challan-result-header">
//                           <div>
//                             <div className="challan-result-header-label">
//                               CHALLAN REPORT
//                             </div>

//                             <h2>{normalizeVehicleNumber(carNumber)}</h2>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="challan-summary">
//                         <div className="challan-summary-card">
//                           <span className="summary-icon">
//                             <svg viewBox="0 0 24 24">
//                               <path
//                                 d="M4 5h16v14H4zM8 9h8M8 13h5"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="1.8"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               />
//                             </svg>
//                           </span>

//                           <div>
//                             <span>Total Challans</span>
//                             <strong>{challanData.length}</strong>
//                           </div>
//                         </div>

//                         <div className="challan-summary-card amount">
//                           <span className="summary-icon">₹</span>

//                           <div>
//                             <span>Total Amount</span>
//                             <strong>{formatRupee(totalAmount)}</strong>
//                           </div>
//                         </div>
//                       </div>
//                       {challanData.map((data, i) => (
//                         <div className="challan-div" key={data?.challanNumber}>
//                           <span style={{ fontSize: "16px" }}>
//                             Challan No-{data?.challan_number}
//                           </span>
//                           <div className="ch-details">
//                             <div>
//                               <span>Name- </span>
//                               {data?.accused_name}
//                             </div>
//                             <div>
//                               <span>Challan Place</span> - {data?.challan_place}
//                             </div>
//                             <div>
//                               <span>RTO</span> - {data?.rto}
//                             </div>
//                             <div>
//                               <span>State</span> - {data?.state}
//                             </div>
//                             <div>
//                               <span>Challan Date</span> -{" "}
//                               {/* {new Date(data?.challan_date).toLocaleDateString(
//                                 "es-CL",
//                               )} */}
//                               {formatDate(data?.challan_date)}
//                               {" : "}
//                               {data?.challan_date_time?.split("T")?.[1]}
//                             </div>
//                             <div>
//                               <span>Amount</span> -{" "}
//                               {formatRupee(parseFloat(data?.amount) || 0)}
//                             </div>
//                             <div>
//                               <span>Challan Status</span> -{" "}
//                               {data?.challan_status}
//                             </div>

//                             <div>
//                               <span>Offense Detail</span> -{" "}
//                               {data?.offense_details}
//                             </div>
//                             <div>
//                               <span>Court Challan</span> -{" "}
//                               {data?.court_challan === true ? "Yes" : "No"}
//                             </div>
//                           </div>

//                           {/* {challanData.length === i + 1 && (
//                             <h1 className="mt-3 text-center text-danger">
//                               Total Challan :{" "}
//                               {formatRupee(parseFloat(totalAmount) || 0)}
//                             </h1>
//                           )} */}
//                         </div>
//                       ))}
//                     </div>
//                   </>
//                 )}
//               </div>
//             </section>
//           )}
//         </main>
//       </div>
//     </>
//   );
// }

// export default Challan;
